import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-right: 1em;
  padding: 0.2em 0 0.2em 0;
  display: inline-flex;
  align-items: center;
`

const Checkbox = styled.input`
  margin: 0 0.2em 0 0;
`

const Label = styled.label`
  font-size: 1em;
`

class LabeledCheckBox extends React.Component {
  render() {
    let {
      label,
      id,
      type,
      checked,
      onChange,
    } = this.props;

    return (
      <Container onClick={onChange}>
        <Checkbox
          type={type}
          id={id}
          value={id}
          readOnly
          checked={checked} />
        <Label>
          {label}
        </Label>
      </Container>
    );
  }
}

export default LabeledCheckBox;